import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightBtn", "darkBtn", "lightPreview", "darkPreview", "embedCode"]

  switchLight() {
    this.lightBtnTarget.className = "px-3 py-1.5 text-sm font-medium rounded-lg bg-slate-900 text-white cursor-pointer"
    this.darkBtnTarget.className = "px-3 py-1.5 text-sm font-medium rounded-lg bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 cursor-pointer"
    this.lightPreviewTarget.classList.remove("hidden")
    this.darkPreviewTarget.classList.add("hidden")
    this.embedCodeTarget.value = this.embedCodeTarget.dataset.lightCode.replace(/&quot;/g, '"')
  }

  switchDark() {
    this.darkBtnTarget.className = "px-3 py-1.5 text-sm font-medium rounded-lg bg-slate-900 text-white cursor-pointer"
    this.lightBtnTarget.className = "px-3 py-1.5 text-sm font-medium rounded-lg bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 cursor-pointer"
    this.darkPreviewTarget.classList.remove("hidden")
    this.lightPreviewTarget.classList.add("hidden")
    this.embedCodeTarget.value = this.embedCodeTarget.dataset.darkCode.replace(/&quot;/g, '"')
  }
}
